/** Hook for reading the active onboarding hint queue context value. */
// @ts-check
import { useContext } from 'react';
import { OnboardingHintQueueContext } from '@/features/onboarding/context/OnboardingHintQueueContext.def';

export function useOnboardingHintQueueContext() {
  return useContext(OnboardingHintQueueContext);
}
